import { Ref, ref, UnwrapRef, watch } from '@vue/composition-api'

export const useVModel = <T = any>(
  value: Ref<T>,
  emit: Function,
  event = 'input',
) => {
  const model = ref(value.value)
  watch(
    () => model.value,
    value => emit(event, value),
  )
  watch(
    () => value.value,
    value => (model.value = value as UnwrapRef<T>),
  )
  return model
}
